import { FormDataPersonalInformation } from ".";
import { emptyValues as emptyValuesPerson } from "../FormPartialPerson/emptyValues";
import { emptyValuesUsPersonInfo } from "../FormPartialUsPersonInfo/emptyValues";

export const emptyValues: FormDataPersonalInformation = {
  person: emptyValuesPerson,
  usPerson: emptyValuesUsPersonInfo
};
